"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ArrowsIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ArrowsIcon, _React$PureComponent);

  function ArrowsIcon() {
    _classCallCheck(this, ArrowsIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(ArrowsIcon).apply(this, arguments));
  }

  _createClass(ArrowsIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'arrows-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M9.99977501,6.99995834 C10.2557686,6.99995834 10.5117622,7.09795425 10.7067573,7.29294613 C11.0977476,7.68392984 11.0977476,8.3159035 10.7067573,8.70688721 L7.70683233,11.7067622 C7.3158421,12.0977459 6.6838579,12.0977459 6.29286768,11.7067622 C5.90187745,11.3157785 5.90187745,10.6838048 6.29286768,10.2928211 L7.58583535,8.99987501 L1.999975,8.99987501 C1.44698883,8.99987501 1,8.55289363 1,7.99991667 C1,7.44693971 1.44698883,6.99995834 1.999975,6.99995834 L9.99977501,6.99995834 Z M5.70698233,0.293237782 C6.09797255,0.684221491 6.09797255,1.31619516 5.70698233,1.70717887 L4.41401465,3.00012499 L9.999875,3.00012499 C10.5528612,3.00012499 10.99985,3.44710637 10.99985,4.00008333 C10.99985,4.55306029 10.5528612,5.00004166 9.999875,5.00004166 L2.000075,5.00004166 C1.58608535,5.00004166 1.23009425,4.74805216 1.07809805,4.39006708 C0.927101822,4.01608266 1.0001,3.58610058 1.29309267,3.29311279 L4.29301767,0.293237782 C4.6840079,-0.0977459273 5.3159921,-0.0977459273 5.70698233,0.293237782 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return ArrowsIcon;
}(_react.default.PureComponent);

exports.default = ArrowsIcon;
ArrowsIcon.defaultProps = {
  color: 'inherit'
};
ArrowsIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};